<template>
  <vx-card class="mb-5">
    <div class="vx-row my-0">
      <div class="vx-col md:w-1/4 w-full">
        <v-date-picker
          v-model="selectedDate"
          mode="date"
          is-range
          is24hr
          :locale="$i18n.locale"
          :buddhist="true"
          :max-date="new Date()"
        >
          <template v-slot="{ inputEvents }">
            <vs-input
              v-on="inputEvents.start"
              :label="isResignation ? 'วันที่ออกจากโครงการ': 'วันที่ลงทะเบียน'"
              :value="
                selectedDate.start &&
                `${
                  selectedDate.start ? formateDate(selectedDate.start) : ''
                } - ${selectedDate.end ? formateDate(selectedDate.end) : ''}`
              "
              class="w-full"
              placeholder="วัน/เดือน/ปี - วัน/เดือน/ปี"
            />
          </template>
        </v-date-picker>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <form autocomplete="off" class="w-full">
          <vs-select
            class="w-full select-large"
            label="สำนักงานสรรพสามิตพื้นที่"
            v-model="zone"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="`${item.name} ${
                item.branch != null ? '(' + item.branch + ')' : ''
              }`"
              v-for="(item, index) in zoneList"
              class="w-full"
            />
          </vs-select>
        </form>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <form autocomplete="off" class="w-full">
          <vs-select
            class="w-full select-large"
            label="ประเภทบุคคล"
            v-model="personType"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="`${item.name}`"
              v-for="(item, index) in personTypeList"
              class="w-full"
            />
          </vs-select>
        </form>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="ชื่อผู้ยื่นคำขอ / ชื่อนิติบุคล"
          class="w-full"
          v-model="requestName"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="เลขบัตรประชาชน / เลขนิติบุคคล"
          class="w-full"
          id="card_id_owner"
          v-model="requestCardNumber"
          maxlength="17"
          placeholder="X-XXXX-XXXXX-XX-X"
          @change="checkCardNumber()"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="ชื่อผู้ควบคุมเรือ/ไต๋เรือ/ผู้ทำการประมง"
          class="w-full"
          v-model="ownerName"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="เลขบัตรประชาชนผู้ควบคุมเรือ/ไต๋เรือ/ผู้ทำการประมง"
          class="w-full"
          id="card_id_ship_man"
          maxlength="17"
          placeholder="X-XXXX-XXXXX-XX-X"
          v-model="cardNumberOwner"
          @change="checkCardShipNumber()"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="รหัสรับน้ำมัน"
          class="w-full"
          v-model="receiveOilCode"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input label="ชื่อเรือ" class="w-full" v-model="vesselName" />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="หมายเลขทะเบียนเรือ"
          class="w-full"
          v-model="registrationNumber"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input label="MMSI" class="w-full" v-model="mmsi" />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <form autocomplete="off" class="w-full">
          <vs-select
            class="w-full select-large"
            label="ประเภทเรือ"
            v-model="vesselType"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item.vesselType"
              :text="item.vesselType"
              v-for="(item, index) in vesselTypeList"
              class="w-full"
            />
          </vs-select>
        </form>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <form autocomplete="off" class="w-full">
          <vs-select
            class="w-full select-large"
            label="ประเภทการใช้"
            v-model="usageType"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item.usageType"
              :text="item.usageType"
              v-for="(item, index) in usageTypeList"
              class="w-full"
            />
          </vs-select>
        </form>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <form autocomplete="off" class="w-full">
          <vs-select
            class="w-full select-large"
            label="สถานะ"
            v-model="status"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="`${item.name}`"
              v-for="(item, index) in isResignation ? statusResignationList : statusList"
              class="w-full"
            />
          </vs-select>
        </form>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="flex">
          <vs-input
            type="number"
            label="ปริมาณความจุถังน้ำมัน"
            class="w-1/2 mr-1"
            v-model="capacity.start"
          />
          <vs-input
            type="number"
            label="ถึง"
            class="w-1/2 ml-1"
            v-model="capacity.end"
          />
        </div>
      </div>

      <div class="vx-col md:w-1/4 w-full">
        <div class="flex">
          <vs-input
            type="number"
            label="ตันกรอส"
            class="w-1/2 mr-1"
            v-model="tonGross.start"
          />
          <vs-input
            type="number"
            label="ถึง"
            class="w-1/2 ml-1"
            v-model="tonGross.end"
          />
          <!-- <vs-select
            class="w-1/2 mr-1 select-large"
            label="ตันกรอส"
            v-model="tonGross"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="`${item.name}`"
              v-for="(item, index) in tonGrossTonNetList"
              class="w-full"
            />
          </vs-select> -->
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="flex">
          <vs-input
            type="number"
            class="w-1/2 ml-1 select-large"
            label="ตันเนต"
            v-model="tonNet.start"
          />
          <vs-input
            type="number"
            label="ถึง"
            class="w-1/2 ml-1"
            v-model="tonNet.end"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input
          label="ใบอนุญาตทำการประมง"
          class="w-full"
          v-model="fisheriesLicense"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full mt-6 text-center">
        <vs-button
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-search"
          @click="advanceSearch('advanced search')"
          >ค้นหา</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "AdvanceSearch",
  props: {
    isResignation: {
      type: Boolean,
    },
  },
  data() {
    return {
      zone: null,
      personType: null,
      receiveOilCode: null,
      requestName: null,
      requestCardNumber: null,
      ownerName: null,
      cardNumberOwner: null,
      mmsi: null,
      vesselType: null,
      usageType: null,
      status: this.isResignation ? "ออกจากโครงการ" : null,
      registrationNumber: null,
      requestCardNumberNew: null,
      requestCardShipNumberNew: null,
      vesselName: null,
      capacity: {
        start: null,
        end: null,
      },
      tonGross: {
        start: null,
        end: null,
      },
      tonNet: {
        start: null,
        end: null,
      },
      fisheriesLicense: null,
      selectedDate: {
        start: null,
        end: null,
      },
      personTypeList: [
        {
          id: 0,
          name: "ทั้งหมด",
        },
        {
          id: 1,
          name: "บุคคลทั่วไป",
        },
        {
          id: 2,
          name: "นิติบุคคล",
        },
        {
          id: 3,
          name: "อื่นๆ",
        },
      ],
      statusList: [
        {
          id: 0,
          name: "ทั้งหมด",
        },
        {
          id: 1,
          name: "รอยืนยันการลงทะเบียนเรือ",
        },
        {
          id: 2,
          name: "ยืนยันการลงทะเบียนเรือ",
        },
        {
          id: 3,
          name: "แจ้งรับอุปกรณ์ติดตั้งเรือ",
        },
        {
          id: 4,
          name: "รอการติดตั้งอุปกรณ์",
        },
        {
          id: 5,
          name: "ยืนยันการติดตั้งอุปกรณ์",
        },
      ],
      statusResignationList: [
        {
          id: 0,
          name: "ทั้งหมด",
        },
        {
          id: 1,
          name: "รอยืนยันออกจากโครงการ",
        },
        {
          id: 2,
          name: "ออกจากโครงการ",
        },
      ],
      zoneList: [
        {
          id: 0,
          name: "ทั้งหมด",
          branch: null,
        },
      ],
      vesselTypeList: [
        {
          id: 0,
          vesselType: "ทั้งหมด",
        },
      ],
      usageTypeList: [
        {
          id: 0,
          usageType: "ทั้งหมด",
        },
      ],
      tonGrossTonNetList: [
        {
          id: 0,
          name: "ทั้งหมด",
          start: null,
          end: null,
        },
        {
          id: 1,
          name: "0 - 9.9",
          start: null,
          end: 9.9,
        },
        {
          id: 2,
          name: "10 - 19.9",
          start: 10,
          end: 19.9,
        },
        {
          id: 3,
          name: "20 - 29.9",
          start: 20,
          end: 29.9,
        },
        {
          id: 4,
          name: "30 +",
          start: 30,
          end: null,
        },
      ],
    };
  },
  async mounted() {
    await this.$store.dispatch("users/getZone");
    await this.$store.dispatch("users/getVesselType");
    await this.$store.dispatch("users/getUsageType");

    this.zoneList.push(...this.zones);
    this.vesselTypeList.push(...this.vesselTypes);
    this.usageTypeList.push(...this.usageTypes);

    this.search = {
      zoneId: this.zone ? (this.zone.id == 0 ? null : this.zone.id) : null,
      personType: this.personType
        ? this.personType.name == "ทั้งหมด"
          ? null
          : this.personType.name
        : null,
      receiveOilCode: this.receiveOilCode,
      mmsi: this.mmsi,
      vesselType: this.vesselType == "ทั้งหมด" ? null : this.vesselType,
      usageType: this.usageType == "ทั้งหมด" ? null : this.usageType,
      status: this.status
        ? this.status.id == 0
          ? null
          : this.status.name
        : null,
    };
    localStorage.setItem("search", JSON.stringify(this.search));
    this.checkNumber();
    $("#card_id_owner,#card_id_ship_man").on("keypress", function () {
      const value = $(this).val();
      if (value.length == 1) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 6) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 12) {
        $(this).val($(this).val() + "-");
      } else if (value.length == 15) {
        $(this).val($(this).val() + "-");
      }
      console.log($(this).val());
    });
  },
  computed: {
    ...mapState({
      zones: (state) => state.users.zone,
      vesselTypes: (state) => state.users.vesselType,
      usageTypes: (state) => state.users.usageType,
    }),
  },
  methods: {
    formateDate(date) {
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    async advanceSearch(type) {
      this.$vs.loading({});
      if (this.requestCardNumber) {
        let cutDashCardVessels = this.requestCardNumber.split("-");
        let cardNumberVessel = "";
        for (const cutDashCardVessel of cutDashCardVessels) {
          cardNumberVessel += cutDashCardVessel;
        }
        this.requestCardNumberNew = cardNumberVessel;
        console.log("this is card vessel :", this.requestCardNumberNew);
      }
      //cardNumberOwner cut('-')
      if (this.cardNumberOwner) {
        let cutDashCardShipVessels = this.cardNumberOwner.split("-");
        let cardNumberShipVessel = "";
        for (const cutDashCardShipVessel of cutDashCardShipVessels) {
          cardNumberShipVessel += cutDashCardShipVessel;
        }
        this.requestCardShipNumberNew = cardNumberShipVessel;
        console.log("this is card vessel :", this.requestCardShipNumberNew);
      }
       const checkStatus = this.status
          ? this.status.id == 0
            ? null
            : this.status.name
          : null;

      this.search = {
        type,
        date:
          this.selectedDate.start && this.selectedDate.end
            ? this.selectedDate
            : null,
        zoneId: this.zone ? (this.zone.id == 0 ? null : this.zone.id) : null,
        personType: this.personType
          ? this.personType.name == "ทั้งหมด"
            ? null
            : this.personType.name
          : null,
        receiveOilCode: this.receiveOilCode ? this.receiveOilCode : null,
        mmsi: this.mmsi ? this.mmsi : null,
        vesselType: this.vesselType == "ทั้งหมด" ? null : this.vesselType,
        usageType: this.usageType == "ทั้งหมด" ? null : this.usageType,
        status: checkStatus,
        registrationNumber: this.registrationNumber
          ? this.registrationNumber
          : null,
        vesselName: this.vesselName ? this.vesselName : null,
        capacity:
          this.capacity.start || this.capacity.end ? this.capacity : null,
        tonGross:
          this.tonGross.start || this.tonGross.end ? this.tonGross : null,
        tonNet: this.tonNet.start || this.tonNet.end ? this.tonNet : null,
        fisheriesLicense: this.fisheriesLicense ? this.fisheriesLicense : null,

        requestName: this.requestName ? this.requestName : null,
        requestCardNumber: this.requestCardNumberNew
          ? this.requestCardNumberNew
          : null,
        ownerName: this.ownerName ? this.ownerName : null,
        cardNumberOwner: this.requestCardShipNumberNew
          ? this.requestCardShipNumberNew
          : null,
      };

      console.log("search ", this.search);
      localStorage.setItem("search", JSON.stringify(this.search));
      if (this.isResignation) {
        console.log("searchResignations >>> ", type);
        await this.$store.dispatch("resignations/getResignationStatus", this.search);
      } else {
        await this.$store.dispatch("vessels/setVessels", this.search);
      }
      this.$vs.loading.close();
    },
    checkCardNumber() {
      console.log("this is test ");
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = this.requestCardNumber.replace(/-/g, "");
      console.log("this is IPID ____>", iPID);
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }
      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
    },
    //cardNumberOwner
    checkCardShipNumber() {
      console.log("this is test ");
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = this.cardNumberOwner.replace(/-/g, "");
      console.log("this is IPID ____>", iPID);
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }
      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
    },
    checkNumber() {
      $(document).ready(function () {
        $("#card_id_owner,#card_id_ship_man, #mmsi").bind(
          "keypress",
          function (evt) {
            var key = String.fromCharCode(evt.which || evt.charCode);
            if (/[\d -]/.test(key) === false) return evt.preventDefault();
          }
        );
      });
    },
  },
  components: {},
};
</script>

<style lang="scss"></style>
